module.exports = __webpack_public_path__ + "static/media/graduation-color.4fda3d64.jpg";